import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import * as _ from 'underscore';
import {Observable} from 'rxjs';
import {share} from 'rxjs/operators';


@Injectable()
export abstract class ServerApiService {
  protected abstract baseUrl: string;
  protected authenticateRequest = true;

  constructor(protected http: HttpClient) {
  }

  protected getCommonHeaders(): HttpHeaders {
    let authInfo = null;
    try {
      authInfo = JSON.parse(localStorage.getItem('auth_info'));
    } catch (e) {
    }
    if (this.authenticateRequest && authInfo) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authInfo['access_token']
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json'
      });
    }
  }

  protected getAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('auth_info'))['access_token'],
    });
  }

  private getHeaders(extraHeaders?: { name: string, value: string }[]) {
    let headers = this.getCommonHeaders();
    if (extraHeaders) {
      _.each(extraHeaders, header => {
        headers = headers.delete(header.name);
        headers = headers.append(header.name, header.value);
      });
    }
    return headers;
  }

  protected runServerGetAction(urlPath: string, extraHeaders?: { name: string, value: string }[]): Observable<Object> {
    const headers = this.getHeaders(extraHeaders);
    const url = this.getFullUrl(urlPath);
    const getObservable = this.http.get(url, {headers: headers, observe: 'response'}).pipe(share());
    return getObservable;
  }

  protected runServerPostAction(urlPath: string, postData: Object = {},
                                extraHeaders?: { name: string, value: string }[]): Observable<Object> {
    const headers = this.getHeaders(extraHeaders);
    const url = this.getFullUrl(urlPath);
    const postObservable = this.http.post(url, postData, {headers: headers}).pipe(share());
    return postObservable;
  }

  protected runServerPutAction(urlPath: string, putData: Object = {},
                               extraHeaders?: { name: string, value: string }[]): Observable<Object> {
    const headers = this.getHeaders(extraHeaders);
    const url = this.getFullUrl(urlPath);
    const putObservable = this.http.put(url, putData, {headers: headers}).pipe(share());
    return putObservable;
  }

  protected runServerPatchAction(urlPath: string, patchData: Object = {},
                               extraHeaders?: { name: string, value: string }[]): Observable<Object> {
    const headers = this.getHeaders(extraHeaders);
    const url = this.getFullUrl(urlPath);
    const patchObservable = this.http.patch(url, patchData, {headers: headers}).pipe(share());
    return patchObservable;
  }

  protected runServerDeleteAction(urlPath: string): Observable<any> {
    const headers = this.getCommonHeaders();
    const url = this.getFullUrl(urlPath);
    const deconsteObservable = this.http.delete(url, {headers: headers, responseType: 'text'}).pipe(share());
    return deconsteObservable;
  }

  protected runServerHeadAction(urlPath: string): Observable<Object> {
    const headers = this.getCommonHeaders();
    const url = this.getFullUrl(urlPath);
    const getObservable = this.http.head(url, {headers: headers, responseType: 'text'}).pipe(share());
    return getObservable;
  }

  protected runServerHttpAction(method: string, urlPath: string, body?: any, specialHeaders?: HttpHeaders): Observable<Object> {
    const headers = (specialHeaders != null) ? specialHeaders : this.getCommonHeaders();
    const url = this.getFullUrl(urlPath);
    const getObservable = this.http.request(method, url,
      {
        body,
        headers,
        responseType: 'json',
        reportProgress: false,
      }
    ).pipe(share());
    return getObservable;
  }

  private getFullUrl(urlPath: string): string { // allow external base URL
    let url;
    try {
      url = new URL(urlPath).toString();
    } catch (error) {
      if (urlPath.startsWith('/')) {// avoid double slash
        urlPath = urlPath.substring(1);
      }
      url = (this.baseUrl) != null ? `${this.baseUrl}${urlPath}` : urlPath;
    }
    return encodeURI(url);
  }
}
